import { Trans } from '@lingui/react/macro';

import { InputSearchSelect } from '@/design_system/InputSearchSelect/InputSearchSelect';
import { EntityGroup, useEntityGroups } from '@/models/entityGroup';

export const GroupsSelector = ({
  groups,
  setGroups,
}: {
  groups: {
    id: string;
    name: string;
  }[];
  setGroups: (
    groups: {
      id: string;
      name: string;
    }[]
  ) => void;
}) => {
  const { data: { entityGroups } = { entityGroups: [] } } = useEntityGroups({
    limit: 100,
  });

  const options = entityGroups.filter((group) => !groups.find(({ id }) => id === group.id));

  return (
    <InputSearchSelect
      isMulti
      label={<Trans id="groups-selector.label">Groups</Trans>}
      value={groups}
      options={options}
      getOptionValue={(option) => option.id}
      getOptionLabel={(option) => option.name}
      onRemoveValue={(value) => setGroups(groups.filter((group) => group.id !== value))}
      onChange={(values) => setGroups(values as EntityGroup[])}
    />
  );
};
